// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"6acadcbb3528a1d673d8","180":"c13f1ce58e9a56fa0ac9","229":"f4dc57180cec69efd07d"}[chunkId] + ".css";
};